import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchClaimDataTypes } from 'common/services/api/ClaimDataTypes/ClaimDataTypes.thunks';
import { ClaimDataType } from 'common/types/Entities';

import type { RootState } from '../../app/store';

type ClaimDataTypesState = {
    claimDataTypes: ClaimDataType[],
    loaded: boolean
};

const initialState: ClaimDataTypesState = {
    claimDataTypes: [],
    loaded: false
};

const claimDataTypesSlice = createSlice({
    name: 'claimDataTypes',
    initialState,
    reducers: () => ({}),

    extraReducers: builder => {
        builder.addCase(fetchClaimDataTypes.pending, state => {
            state.loaded = false;
            state.claimDataTypes = [];
        });
        builder.addCase(fetchClaimDataTypes.fulfilled, (state, action: PayloadAction<ClaimDataType[]>) => {
            state.loaded = true;
            state.claimDataTypes = action.payload;
        });
        builder.addCase(fetchClaimDataTypes.rejected, state => {
            state.loaded = false;
            state.claimDataTypes = [];
        });
    }
});

// eslint-disable-next-line no-restricted-syntax
export default claimDataTypesSlice.reducer;
export const selectClaimDataTypes = (state: RootState) => state.claimDataTypes.claimDataTypes;
